<template>
  <li class="page-item" :class="{ disabled: disabled }">
    <a class="page-link" :href="href" @click.prevent="$emit('click')"><slot /></a>
  </li>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    href: function () {
      if (!this.disabled) {
        return '#'
      }
    }
  }
}
</script>
